import { DatePicker as MDatePicker } from '@mantine/dates';
import classes from './datePicker.module.scss';

export const DatePicker = MDatePicker.extend({
  classNames: classes,
});
